import React from 'react';
import PropTypes from 'prop-types';
import Text from 'shared/components/text';

const propTypes = {
  emoji: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  ]),
};

const FooterTextWithEmoji = ({emoji, text}) => (
  <div className="registration-footer-text-with-emoji">
    <div className="registration-footer-text-with-emoji-emoji">{emoji}</div>

    <Text showOverflow emphasis>
      {text}
    </Text>
  </div>
);

FooterTextWithEmoji.propTypes = propTypes;

export default FooterTextWithEmoji;
